import { action } from "mobx";
import { Strings } from "../Stores/StringsStore";
import { IWizardStore, WizardStore } from "./AppStore";
import { DocumentStoreImpl } from "./DocumentStore";


export class FileLanguageWizardStore extends WizardStore implements IWizardStore {

	constructor(public documentStore: DocumentStoreImpl) {
		super();
	}

	/**
  * Open the wizard for adding meta data.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.fileEdit.selectLanguageCaption;
		this.wizardInformation = Strings.documentManagement.fileEdit.selectLanguageText;
		this.confirmEnabled = false;
		this.isOpen = true;
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.isOpen = false;
		this.onConfirmExternal();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
	}

}